import * as Yup from 'yup';
import { parseDecimal } from '../AddUserProduct/helpers';

// Per-portion values: a single portion can legitimately reach four digits (a 1 500 kcal takeaway),
// so the cap is a sanity bound rather than a physical one. `.` and `,` both accepted.
const DECIMAL_REGEX = /^\d{1,4}([.,]\d+)?$/;
export const MAX_QUICK_MEAL_CALORIES = 9999;
export const MAX_QUICK_MEAL_MACRO_GRAMS = 9999;

const REQUIRED = 'tracker.logMeal.input.validationError.empty';
const INVALID = 'validation.invalidNumber';
const TOO_HIGH = 'validation.valueTooHigh';

const nutritionField = (max: number, required: boolean) => {
  let schema = Yup.string()
    .test('decimal-format', INVALID, (value) =>
      value == null || value === '' ? true : DECIMAL_REGEX.test(value)
    )
    .test('max-value', TOO_HIGH, (value) =>
      value == null || value === '' ? true : parseDecimal(value) <= max
    );
  if (required) schema = schema.required(REQUIRED);
  return schema;
};

/**
 * Builds the schema for the quick meal form. Date/time exist only when logging to the tracker,
 * servings only where the user can change them (not on a Your Meals template's details).
 */
const quickMealValidationSchema = ({
  withDateTime,
  withServings,
}: {
  withDateTime: boolean;
  withServings: boolean;
}) =>
  Yup.object({
    ...(withDateTime
      ? {
          date: Yup.string().required(REQUIRED),
          time: Yup.string().required(REQUIRED),
        }
      : {}),
    ...(withServings
      ? {
          servings: Yup.number()
            .typeError(REQUIRED)
            .min(0.1, 'tracker.servings.validation.description')
            .max(30, 'tracker.servings.validation.description')
            .required(REQUIRED),
        }
      : {}),
    mealName: Yup.string()
      .trim()
      .required(REQUIRED)
      .max(120, 'tracker.logMeal.mealName.edit.limitReached'),
    calories: nutritionField(MAX_QUICK_MEAL_CALORIES, true),
    protein: nutritionField(MAX_QUICK_MEAL_MACRO_GRAMS, true),
    fat: nutritionField(MAX_QUICK_MEAL_MACRO_GRAMS, true),
    carbs: nutritionField(MAX_QUICK_MEAL_MACRO_GRAMS, true),
    fiber: nutritionField(MAX_QUICK_MEAL_MACRO_GRAMS, false),
    notes: Yup.string().max(1500, 'mealDetails.editNote.limitReached'),
  });

export default quickMealValidationSchema;
